import { BaseApiContract } from "shared/api/apiRequestContractHandler";
import { HttpMethod } from "shared/api/http";
import {
  SocietyAppRouteConfigContentPageParamsInput,
  SocietyAppRouteConfigContentPageBodyInput,
} from "shared/api/types/society/[societyId]/app-route-config/[appRouteConfigId]/content/[contentPageId]";
import { ContentPageView } from "shared/mappers/database/content-page/content-page";
export const getSocietyAppRouteConfigContentPageIdContract: BaseApiContract<
  SocietyAppRouteConfigContentPageParamsInput,
  undefined,
  ContentPageView
> = {
  method: HttpMethod.GET,
  apiRoute:
    "/api/v1/society/[societyId]/app-route-config/[appRouteConfigId]/content/[contentPageId]",
  paramsType: {} as SocietyAppRouteConfigContentPageParamsInput,
  responseType: {} as ContentPageView,
};
export const deleteSocietyAppRouteConfigContentPageIdContract: BaseApiContract<
  SocietyAppRouteConfigContentPageParamsInput,
  undefined,
  ContentPageView
> = {
  method: HttpMethod.DELETE,
  apiRoute:
    "/api/v1/society/[societyId]/app-route-config/[appRouteConfigId]/content/[contentPageId]",
  paramsType: {} as SocietyAppRouteConfigContentPageParamsInput,
  responseType: {} as ContentPageView,
};
export const putSocietyAppRouteConfigContentPageIdContract: BaseApiContract<
  SocietyAppRouteConfigContentPageParamsInput,
  SocietyAppRouteConfigContentPageBodyInput,
  ContentPageView
> = {
  method: HttpMethod.PUT,
  apiRoute:
    "/api/v1/society/[societyId]/app-route-config/[appRouteConfigId]/content/[contentPageId]",
  paramsType: {} as SocietyAppRouteConfigContentPageParamsInput,
  bodyType: {} as SocietyAppRouteConfigContentPageBodyInput,
  responseType: {} as ContentPageView,
};
